"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const data_1 = require("../engine/data");
const scenario_variable_1 = require("./scenario-variable");
const scenario_type_service_1 = require("./scenario-type-service");
var Sexes;
(function (Sexes) {
    Sexes["male"] = "1";
    Sexes["female"] = "2";
})(Sexes || (Sexes = {}));
const sexVariable = 'DHH_SEX';
function shouldModifyVariable(individual, scenarioVariable) {
    if (scenario_type_service_1.isVariableRange(scenarioVariable.targetPop)) {
        return scenarioVariable.targetPop.every(targetVariable => isVariableWithinRange(individual, scenarioVariable.variableName, targetVariable.range));
    }
    else {
        return isVariableWithinRange(individual, scenarioVariable.variableName, scenarioVariable.targetPop);
    }
}
exports.shouldModifyVariable = shouldModifyVariable;
function isVariableWithinRange(individual, variableName, range) {
    const variableValue = Number(data_1.findDatumWithName(variableName, individual).coefficent);
    let [min, max] = range;
    if (min === null)
        min = -Infinity;
    else if (min === 'scenarioValue')
        min = variableValue;
    if (max === null)
        max = Infinity;
    else if (max === 'scenarioValue')
        max = variableValue;
    return variableValue >= min && variableValue <= max;
}
exports.isVariableWithinRange = isVariableWithinRange;
/**
 * @description Update individual's variable value according to the continuous variable method
 * @param scenarioVariable Scenario variable
 * @param targetVariable Individual's variable to be modified
 * @param targetVariablePrevalence Variables prevalence
 */
function runVariableMethodContinuous(scenarioVariable, targetVariable) {
    const coefficient = Number(targetVariable.coefficent);
    switch (scenarioVariable.method) {
        case scenario_variable_1.VariableMethods.AbsoluteScenario: {
            targetVariable.coefficent =
                coefficient + scenarioVariable.scenarioValue;
            break;
        }
        case scenario_variable_1.VariableMethods.AttributionScenario: {
            targetVariable.coefficent = scenarioVariable.scenarioValue;
            break;
        }
        case scenario_variable_1.VariableMethods.RelativeScenario: {
            targetVariable.coefficent =
                coefficient * (1 + scenarioVariable.scenarioValue);
            break;
        }
    }
    targetVariable.coefficent = String(targetVariable.coefficent);
}
exports.runVariableMethodContinuous = runVariableMethodContinuous;
/**
 * @description Update individual's variable value according to the component variable method
 * @param individual Individual
 * @param scenarioVariable Scenario variable
 * @param targetVariable Individual's variable to be modified
 */
function runVariableMethodComponent(individual, scenarioVariable, targetVariable) {
    let targetVariableCoefficient = Number(targetVariable.coefficent);
    const parentVariable = data_1.findDatumWithName(scenarioVariable.parentVariable, individual);
    const parentVariableCoefficient = Number(parentVariable.coefficent);
    switch (scenarioVariable.method) {
        case scenario_variable_1.VariableMethods.ComponentTargetScenario:
        case scenario_variable_1.VariableMethods.ComponentAttributionScenario: {
            targetVariableCoefficient =
                targetVariableCoefficient +
                    scenarioVariable.scenarioValue -
                    parentVariableCoefficient;
            break;
        }
        case scenario_variable_1.VariableMethods.ComponentAbsoluteScenario: {
            targetVariableCoefficient =
                targetVariableCoefficient + scenarioVariable.scenarioValue;
            break;
        }
        case scenario_variable_1.VariableMethods.ComponentRelativeScenario: {
            targetVariableCoefficient =
                targetVariableCoefficient +
                    (parentVariableCoefficient *
                        (1 + scenarioVariable.scenarioValue) -
                        parentVariableCoefficient);
            break;
        }
    }
    targetVariable.coefficent = String(targetVariableCoefficient);
}
exports.runVariableMethodComponent = runVariableMethodComponent;
function getScenarioConfigForSex(individual, scenario) {
    const sex = data_1.findDatumWithName(sexVariable, individual).coefficent;
    if (sex === Sexes.male)
        return scenario.male;
    else
        return scenario.female;
}
exports.getScenarioConfigForSex = getScenarioConfigForSex;
/**
 * @description Limit a variable to ensure it's new value is within the scenario post-calculation range
 * @param targetVariable Target variable
 * @param scenarioVariable Scenario variable
 */
function applyPostScenarioRange(targetVariable, scenarioVariable) {
    if (scenarioVariable.postScenarioRange) {
        let updatedTargetValue = scenarioVariable.scenarioValue;
        // Ensure new value is limited to be within scenario min/max range
        let [min, max] = scenarioVariable.postScenarioRange;
        if (min === null)
            min = -Infinity;
        else if (min === 'scenarioValue')
            min = updatedTargetValue;
        if (max === null)
            max = Infinity;
        else if (max === 'scenarioValue')
            max = updatedTargetValue;
        if (updatedTargetValue < min)
            updatedTargetValue = min;
        else if (updatedTargetValue > max)
            updatedTargetValue = max;
        targetVariable.coefficent = updatedTargetValue.toString();
    }
}
exports.applyPostScenarioRange = applyPostScenarioRange;
function calculateRelativeChange(scenarioVariable, targetVariablePrevalence) {
    switch (scenarioVariable.method) {
        case scenario_variable_1.VariableMethods.AbsoluteScenarioCat: {
            return scenarioVariable.scenarioValue / targetVariablePrevalence;
        }
        case scenario_variable_1.VariableMethods.TargetScenarioCat: {
            return ((scenarioVariable.scenarioValue - targetVariablePrevalence) /
                targetVariablePrevalence);
        }
        case scenario_variable_1.VariableMethods.RelativeScenarioCat: {
            return scenarioVariable.scenarioValue;
        }
    }
}
exports.calculateRelativeChange = calculateRelativeChange;
//# sourceMappingURL=scenario-calculation-service.js.map